export default {
  'meta': {
    'langName': 'GERMAN',
    'lang': 'Deutsch'
  },
  'title': 'PRODUKTRÜCKRUF BASKETBALLKORB B900 BOX NBA TARMAK',
  'description': 'Hallo,\n\nvielen Dank, dass du dich für unseren Basketballkorb B900 BOX NBA Tarmak entschieden hast.\n\nIm Rahmen unseres ständigen Engagements für die Qualität und Sicherheit unserer Produkte haben die Teams von Decathlon Kipsta ein mögliches Risiko festgestellt: Es besteht die Möglichkeit, dass der Pfosten senkrecht herunterfallen könnte, wenn die Kurbel zur Höhenverstellung entfernt und das Produkt bewegt oder benutzt wird.\n\nWir bitten dich, die folgenden Fragen zu beantworten, damit wir dir eine Lösung zur Sicherung deines Produkts anbieten können.\n\nWir entschuldigen uns für die Unannehmlichkeiten und bedanken uns für dein Vertrauen.\n\nDein Decathlon Team',
  'emailConfirmation': {
    'title': 'Bitte bestätige uns als Erstes deine E-Mail-Adresse und das Land deines Wohnsitzes: '
  },
  'fields': {
    'country': 'Land',
    'address': 'Mailadresse',
    'email': 'Mailadresse',
    'phonePrefix': 'Ländervorwahl',
    'phone': 'Telefonnummer',
    'validations': {
      'phoneOrEmail': 'Bitte gib mindestens eine E-Mail-Adresse ODER eine Telefonnummer an.',
      'email': 'Bitte gib eine gültige E-Mail-Adresse ein',
      'phone': 'Bitte gib eine gültige Telefonnummer ein'
    },
    'firstName': 'Nachname',
    'lastName': 'Vorname',
    'deliveryAddress': 'Anschrift',
    'additionalAddress': 'Adresszusatz',
    'city': 'Stadt',
    'zip': 'Postleitzahl',
    'choose': 'Auswählen',
    'required': 'Dieses Feld ist erforderlich'
  },
  'ownerCheck': {
    'title': 'Hast du noch einen oder mehrere Basketballkörbe B900 Box NBA?'
  },
  'yes': 'JA',
  'no': 'NEIN',
  'ownerChanged': {
    'title': 'Hast du die Kontaktdaten des/der aktuellen Eigentümer(s)?',
    'confirmation': 'Liebe Kundin, lieber Kunde,\n\nvielen Dank, dass du bei unserem Qualitätsvorgang mitmachst.\n\nWir entschuldigen uns für die Unannehmlichkeiten und danken dir für dein Vertrauen.\n\nDein Decathlon Team'
  },
  'recall': {
    'title': 'Bitte sag uns, wie viele Basketballkörbe du hast und welche Kurbel sie haben:',
    'descriptionRed': 'Basketballkorb mit abnehmbarer roter Kurbel',
    'descriptionBlack': 'Basketballkorb mit fest montierter schwarzer Kurbel',
    'quantity': 'Menge',
    'notConcerned': 'Liebe Kundin, lieber Kunde,\n\nVielen Dank, dass du bei unserem Qualitätsvorgang mitgemacht hast.\n\nDu kannst ganz beruhigt sein, dein Basketballkorb Tarmak B900 BOX NBA ist nicht von der Rückrufaktion betroffen. Du kannst ihn ohne Bedenken weiter benutzen.\n\nEntschuldige bitte die Unannehmlichkeiten und danke für dein Vertrauen.\n\nDein Decathlon Team\n',
    'concernedProductQuantity': 'Anzahl der nicht konformen Produkte:',
    'concernedProductLabel': 'Nicht konformes Produkt:',
    'confirmation': 'Danke, dass du das Formular ausgefüllt hast. Deine Anfrage ist bei uns eingegangen.\n\nWir schicken dir so schnell wie möglich die Sendungsverfolgungsnummer für dein Reparaturset.\n\nWir wünschen dir noch einen schönen Tag.\n\nDein Decathlon Team'
  },
  'repair': {
    'title': 'Reparatur mit deiner Mithilfe',
    'description': 'Wir haben an bestimmten Basketballkörben TARMAK B900 BOX NBA  (Artikelnummer 4239136) festgestellt, dass das Risiko besteht, dass der Pfosten senkrecht herunterfallen könnte, wenn diese Kurbel entfernt und das Produkt dann verwendet oder bewegt wird. \nAufgrund deiner Antwort gehen wir davon aus, dass dein Produkt von diesem Risiko betroffen ist.\n\nWir bitten dich daher, es nicht mehr zu benutzen, und bieten dir an, dich bei der Nachrüstung dieser Kurbel zu unterstützen, damit du dein Produkt wieder sicher benutzen kannst.\nKeine Sorge, für diese einfache Reparatur brauchst du keine Fachkenntnisse, alles ist in dem Erklärvideo und der Anleitung unten genau beschrieben:',
    'videoLink': 'Link zum Video',
    'docLink': 'Link zur Anleitung',
    'callToAction': 'Hier klicken, um dein kostenloses Reparaturset zu erhalten',
    'warranty': 'Der gesamte Vorgang wird durch unsere 5-jährige Garantie abgedeckt.'
  },
  'repairRequest': {
    'title': 'Bitte gib die folgenden Informationen ein, damit dein kostenloses Set an die Adresse deiner Wahl versandt werden kann:'
  },
  'form': {
    'submit': 'Weiter'
  },
  'status': 'Translation validated by COUNTRY'
} as const
